export const LC_SUBJECTS = [
  'Maths', 'English', 'Irish', 'French', 'German', 'Spanish',
  'Biology', 'Chemistry', 'Physics', 'Agricultural Science',
  'Business', 'Accounting', 'Economics',
  'History', 'Geography', 'Politics & Society',
  'Art', 'Music', 'Home Economics',
  'Construction Studies', 'Engineering', 'DCG (Design & Communication Graphics)',
  'Computer Science', 'Applied Maths',
  'Physical Education', 'LCVP (Link Modules)',
];

export const JC_SUBJECTS = [
  'Maths', 'English', 'Irish', 'French', 'German', 'Spanish',
  'Science', 'Business Studies', 'History', 'Geography',
  'Art/Craft/Design', 'Music', 'Home Economics',
  'Wood Technology', 'Metalwork/Engineering', 'Graphics/Technical Graphics',
  'CSPE', 'SPHE', 'Coding (Short Course)',
];

export const LC_GRADES = ['H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'H7', 'H8', 'O1', 'O2', 'O3', 'O4', 'O5', 'O6', 'O7', 'O8'];
export const JC_GRADES = ['Distinction', 'Higher Merit', 'Merit', 'Achieved', 'Partially Achieved', 'Not Graded'];

export const DIGITAL_SKILLS = [
  'Microsoft Word', 'Microsoft Excel', 'Microsoft PowerPoint', 'Google Workspace',
  'Email & Calendar', 'Social Media Management', 'Basic Coding/HTML',
  'Canva/Graphic Design', 'Video Editing', 'Data Entry',
  'Typing (40+ WPM)', 'Online Research', 'Cloud Storage (Google Drive/OneDrive)',
  'Basic Troubleshooting', 'Photography/Phone Editing',
];

export const PRACTICAL_SKILLS = [
  'Power Tools (Drill, Saw, Grinder)', 'Hand Tools (Hammer, Screwdriver, Wrench)',
  'Soldering/Welding', 'Electrical Wiring Basics', 'Plumbing Basics',
  'Woodwork/Carpentry', 'Painting & Decorating', 'Bricklaying/Plastering',
  'Vehicle Maintenance', 'Cooking/Food Prep', 'First Aid',
  'Forklift/Machinery Operation', 'Gardening/Landscaping',
  'Sewing/Textiles', 'Assembly/Manufacturing',
];

export const SOFT_SKILLS = [
  'Communication', 'Teamwork', 'Problem Solving', 'Time Management',
  'Leadership', 'Attention to Detail', 'Adaptability', 'Work Ethic',
  'Customer Service', 'Organisation', 'Initiative/Self-Starter',
  'Patience', 'Conflict Resolution', 'Creativity', 'Reliability',
];

export const INTERESTS_LIST = [
  'GAA', 'Soccer', 'Rugby', 'Boxing', 'MMA/Martial Arts', 'Swimming',
  'Athletics/Running', 'Cycling', 'Gym/Fitness', 'Basketball', 'Tennis',
  'Golf', 'Horse Riding', 'Hiking/Hillwalking',
  'Gaming', 'Music (Playing)', 'Music (Listening)', 'Singing/Choir',
  'Art/Drawing', 'Photography', 'Cooking/Baking', 'Reading',
  'Coding/Tech Projects', 'Volunteering', 'Scouting/Youth Groups',
  'Drama/Theatre', 'Farming/Agriculture', 'Fishing', 'DIY/Building Projects',
  'Social Media Content Creation',
];

export const INVOLVEMENT_LEVELS = ['Casual/Hobby', 'Club Level', 'Competitive', 'County/National Level'];

export const ACHIEVEMENT_PROMPTS = [
  'Won an award or competition',
  'Completed a course or certification',
  'Led a team or group',
  'Built or created something',
  'Helped in my community',
  'Represented my school/club',
  'Overcame a personal challenge',
  'Organised an event',
  'Mentored or taught someone',
  'Raised money for charity',
];

export const LEADERSHIP_ROLES = [
  'Team Captain', 'School Prefect', 'Class Representative', 'Student Council',
  'Mentor/Buddy', 'Volunteer Coordinator', 'Club Secretary/Treasurer',
  'Youth Group Leader', 'Project Leader', 'Transition Year Coordinator',
];

export const WORK_VALUES = [
  'Job Security', 'Good Pay', 'Learning New Skills', 'Working Outdoors',
  'Helping People', 'Being Creative', 'Working with a Team', 'Independence',
  'Career Progression', 'Work-Life Balance', 'Making a Difference', 'Variety in Work',
];

export const FUTURE_GOALS = [
  'Qualified tradesperson', 'Running my own business', 'Working abroad',
  'Team leader/supervisor', 'Still learning & training', 'Specialist in my field',
  'Teaching/mentoring others', 'Working in tech/innovation',
];

export const WORK_ENVIRONMENTS = [
  'Office-based', 'Outdoors/On-site', 'Workshop/Factory', 'Mix of indoor & outdoor',
  'Healthcare/Hospital setting', 'Retail/Customer-facing', 'Remote/From home', 'Doesn\'t matter to me',
];

export const WORK_TASKS = [
  'Customer service', 'Manual/Physical work', 'Teamwork', 'Problem solving',
  'Cash handling', 'Stock management', 'Cleaning/Maintenance', 'Admin/Data entry',
  'Cooking/Food prep', 'Driving/Deliveries', 'Sales', 'Teaching/Training',
  'Technical/IT work', 'Creative work', 'Caring for others',
];

export const COUNTIES = [
  'Dublin', 'Cork', 'Galway', 'Limerick', 'Waterford', 'Kilkenny',
  'Wexford', 'Kerry', 'Clare', 'Tipperary', 'Mayo', 'Donegal',
  'Sligo', 'Louth', 'Meath', 'Kildare', 'Wicklow', 'Carlow',
  'Laois', 'Offaly', 'Westmeath', 'Longford', 'Roscommon', 'Leitrim',
  'Cavan', 'Monaghan',
];
